import _ from 'underscore'
import React from 'react'
import { ChevronDown } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import DateComponent from '../date'

class CoachbitOrders extends React.Component {

  render() {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Badge asChild variant="secondary" size="md" className="cursor-pointer">
            <button type="button">
              {this.props.coachbit_orders.length} Coachbit Orders <ChevronDown className="inline size-3"/>
            </button>
          </Badge>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          {_.map(this.props.coachbit_orders, (coachbit_order) => {
            return (
              <DropdownMenuItem key={coachbit_order.id} asChild>
                <a href="#"><DateComponent date={coachbit_order.placed_at || coachbit_order.created_at} />: {coachbit_order.checkin_days ? `${coachbit_order.checkin_days} check-in day${coachbit_order.checkin_days === 1 ? '' : 's'}` : null}{coachbit_order.checkin_days && coachbit_order.product_type ? ' · ' : null}{coachbit_order.product_type} {coachbit_order.learner_name ? `for ${coachbit_order.learner_name}` : null}</a>
              </DropdownMenuItem>
            )
          })}
          <DropdownMenuItem asChild>
            <a href={this.props.link} target="_blank">View / Create</a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

export default CoachbitOrders
